import { Box, Tooltip, type TooltipProps } from '@mui/material';
import { styled } from '@mui/material/styles';
import { forwardRef } from 'react';

export interface NWTooltipProps extends TooltipProps {
  maxWidth?: string | number;
}

const MuiTooltip = forwardRef<HTMLDivElement | null, NWTooltipProps>(
  ({ className, children, maxWidth, ...props }, ref) => {
    return (
      <Tooltip
        slotProps={{ tooltip: { sx: { maxWidth } } }}
        {...props}
        ref={ref}
        classes={{ tooltip: className }}
      >
        <Box component="span">{children}</Box>
      </Tooltip>
    );
  },
);

export const NwTooltip = styled(MuiTooltip)(({ theme }) => {
  const { common, grey } = theme.palette;
  const { fontFamily } = theme.typography;
  return {
    backgroundColor: common.white,
    border: `1px solid ${grey['300']}`,
    borderRadius: 0,
    boxShadow: '0 4px 8px 0 rgb(100 102 106 / 15%), 0 8px 16px 0 rgb(100 102 106 / 33%)',
    color: common.black,
    fontFamily,
    fontSize: '.8125rem',
    fontWeight: 'normal',
    lineHeight: '1.53846154',
    padding: '1rem 1rem 0.5rem 1rem',
    '& .MuiTooltip-arrow': {
      color: '#ffffff',
    },
    '& .MuiTooltip-arrow::before': {
      border: `1px solid ${grey['300']}`,
      boxSizing: 'border-box',
    },
  };
});
